import { MutationTree } from "vuex";
import { MapSetupState, MapSetupGroup, MapSetupLayer, MapSetupItem, Map, MapSetupLayerItemRequest, mapItemsUpdated } from "./types";
import { getDefaultState } from "./state";
import Vue from "vue";

export const mutations: MutationTree<MapSetupState> = {
    addMapSetupGroup(state, mapSetupGroup: MapSetupGroup) {
        if (!state.GroupsWithLayers.find((x: MapSetupGroup) => x.groupId == mapSetupGroup.groupId)) {
            state.GroupsWithLayers.push(mapSetupGroup);
        }
    },
    addUpdateMapSetupLayer(state, mapSetupLayer: MapSetupLayer) {
        let index = state.GroupsWithLayers.findIndex((x: MapSetupGroup) => x.groupId == mapSetupLayer.groupId);
        if (state.GroupsWithLayers[index]) {
            let layerIndex = state.GroupsWithLayers[index].mapLayers
                .findIndex((x: MapSetupLayer) => x.mapLayerId == mapSetupLayer.mapLayerId);
            if (layerIndex == -1) {
                state.GroupsWithLayers[index].mapLayers.push(mapSetupLayer);
            }
            else {
                state.GroupsWithLayers[index].mapLayers[layerIndex] = mapSetupLayer;
            }
        }
    },

    updateLayerItemCount(state, mapSetupLayer: MapSetupLayer ) {
        let index = state.GroupsWithLayers.findIndex((x: MapSetupGroup) => x.groupId == mapSetupLayer.groupId);
        if (state.GroupsWithLayers[index]) {
            let layerIndex = state.GroupsWithLayers[index].mapLayers.findIndex((x: MapSetupLayer) => {
                return x.mapLayerId == mapSetupLayer.mapLayerId
            });
            if (state.GroupsWithLayers[index].mapLayers[layerIndex]) {
                state.GroupsWithLayers[index].mapLayers[layerIndex].itemCount = mapSetupLayer.itemCount;
            }
        }
    },

    deleteMapSetupLayer(state, mapSetupLayer: MapSetupLayer) {
        let index = state.GroupsWithLayers.findIndex((x: MapSetupGroup) => x.groupId == mapSetupLayer.groupId);

        if (state.GroupsWithLayers[index]) {
            let layerIndex = state.GroupsWithLayers[index].mapLayers
                .findIndex((x: MapSetupLayer) => x.mapLayerId == mapSetupLayer.mapLayerId)
            if (layerIndex !== -1) {
                state.GroupsWithLayers[index].mapLayers.splice(layerIndex, 1);
            }
        }

    },

    addUpdateMapSetupLayerItem(state, mapSetupItemRequest: MapSetupLayerItemRequest) {
        mapSetupItemRequest.mapSetupLayers.forEach(layer => {

            let groupIndex = state.GroupsWithLayers.findIndex((x: MapSetupGroup) => x.groupId == layer.groupId);

            let groupLayers = state.GroupsWithLayers[groupIndex].mapLayers;

            let layerIndex = groupLayers.findIndex((x: MapSetupLayer) => x.mapLayerId == layer.mapLayerId);
            let itemIndex = groupLayers[layerIndex].layerItems.findIndex((x: MapSetupItem) =>
                x.mapLayerItemID == mapSetupItemRequest.mapSetupLayerItem.mapLayerItemID
            );

            if (itemIndex == -1) {
                groupLayers[layerIndex].layerItems.push(mapSetupItemRequest.mapSetupLayerItem);
            }
            else {
                Vue.set(groupLayers[layerIndex].layerItems,
                    itemIndex,
                    mapSetupItemRequest.mapSetupLayerItem
                );
            }

            groupLayers[layerIndex].itemCount = groupLayers[layerIndex].layerItems.length;
        });

    },
    removeMapSetupItem(state, mapSetupItemRequest: MapSetupLayerItemRequest ) {

        mapSetupItemRequest.mapSetupLayers.forEach(layer => {
            let groupIndex = state.GroupsWithLayers.findIndex((x: MapSetupGroup) =>
                x.groupId == layer.groupId);

            let groupLayers = state.GroupsWithLayers[groupIndex].mapLayers;

            let layerIndex = groupLayers.findIndex((x: MapSetupLayer) => x.mapLayerId == layer.mapLayerId);
            let itemIndex = groupLayers[layerIndex].layerItems.findIndex((x: MapSetupItem) =>
                x.mapLayerItemID == mapSetupItemRequest.mapSetupLayerItem.mapLayerItemID
            );

            if (itemIndex != -1) {
                groupLayers[layerIndex].layerItems.splice(itemIndex, 1);
                groupLayers[layerIndex].itemCount = groupLayers[layerIndex].layerItems.length;
            }
        });
    },

    addMapItemLocationIdentifier(_, { mapLayerItem }) {
        mapLayerItem.locationIdentifiers.push({
            mapLayerItemId: mapLayerItem.mapLayerItemID,
            locationIdentifierId: "",
            locationIdentifierTypeId: 1,
        });
    },

    removeMapItemLocationIdentifier(_, { mapLayerItem, locationIdentifier }) {
        const identifierIndex = mapLayerItem.locationIdentifiers.findIndex(
            i => i.mapLayerItemId == locationIdentifier.mapLayerItemId
            && i.locationIdentifierId == locationIdentifier.locationIdentifierId
            && i.locationIdentifierTypeId == locationIdentifier.locationIdentifierTypeId
        );

        if (identifierIndex !== -1) {
            mapLayerItem.locationIdentifiers.splice(identifierIndex, 1);
        }
    },

    updateAreaLatLong(state, { groupId, latLong }) {
        let groupIndex = state.GroupsWithLayers.findIndex((x: MapSetupGroup) => x.groupId == groupId);
        state.GroupsWithLayers[groupIndex].latLong = `${latLong.lat} ${latLong.lng}`;
    },

    setSelectedLayerId(state, layerId: number | null) {
        state.SelectedMapLayerId = layerId;
    },

    setLayerVisibility(state, { mapSetupLayer, visibility }) {
        let groupIndex = state.GroupsWithLayers.findIndex((x: MapSetupGroup) => x.groupId == mapSetupLayer.groupId);
        let layerIndex = state.GroupsWithLayers[groupIndex].mapLayers
            .findIndex((x: MapSetupLayer) => x.mapLayerId == mapSetupLayer.mapLayerId);

        state.GroupsWithLayers[groupIndex].mapLayers[layerIndex].visible = visibility
    },

    setUnconvertedMaps(state: MapSetupState, maps: Map[]){
        state.unconvertedMaps = maps;
    },

    setNotificationOptions(state: MapSetupState, options: NotificationOptions | null) {
        state.notificationOptions = options;
    },

    deleteMap(state: MapSetupState, mapId: number) {
        const indexToDelete = state.unconvertedMaps.findIndex((m: Map) => m.mapID == mapId);

        if (indexToDelete !== -1)
        {
            state.unconvertedMaps.splice(indexToDelete, 1);
        }
    },

    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};
